import { render } from "./WebRtc.vue?vue&type=template&id=4c119005&scoped=true"
import script from "./WebRtc.vue?vue&type=script&lang=js"
export * from "./WebRtc.vue?vue&type=script&lang=js"

import "./WebRtc.vue?vue&type=style&index=0&id=4c119005&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c119005"]])

export default __exports__